import React, { useEffect, useState } from 'react';
import DistrictPage from './components/DistrictRegistar';
import { useSelector } from 'react-redux';
import { getApmcPurposes, getApmcSchemes, getExistedSchemesAplication, submitAnnexureOnePointOneForm, submitApmcFiles} from '../../auth/services/privateapicalling';
import { useLocation, useNavigate } from 'react-router';
import { toast } from 'react-toastify';

 
// ---------------------------------- IDs ----------------------------------

const DistrictRegistar: React.FC = () => {
  
    const [purposes, setPurposes] = useState<any[]>([]);
    
    
const token = useSelector((state:any)=>state.auth.token);
    const userDetail = useSelector((state:any)=>state.auth.userDetails);
     const location = useLocation()
     const applicationId = location.state?.applicationId;
     const exxData = location.state?.existData;
     const certificate= location.state?.certificateData;
     const siteInspectionPhotos= location.state?.siteInspectionPhotos ||[];
    const [existData ,setExistData] = useState<any | null>(exxData);


     const id= exxData?.scheme?.id;
     const navigate = useNavigate();
     
    const [formData, setFormData] = useState({
      // sanctionOfAssistance: {
        purpose: "",
        estimateProjectCostAmount: "",
        percentOfProjCostEligible: "",
        share: "",
      // },
      marketCommittteGovernmentAssistance:  null as any,
      isOnsiteInspectionCertDistrictRegistrar: "",
      onsiteInspectionCertficateDistrictRegistrarComment: "",
      isConstructApproval: "",
      byWhomConstructApprovalGiven: ""

    });

    const[detailAssistanceReceived, setDetailAssistanceReceived] = useState([]);
    const [currData , setCurrData] = useState({})
 
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string) => {
   
  const { name, files } = e.target;

   if (files && files.length > 0) {
     const file = files[0];
     const fileName = file.name;
      // setItReturns((prev) => ({ ...prev, [name]: files[0] }));
      // setDisableButtonNext(true)
      let docId:any;
      handleUpload(fileName,file, fieldName ,formData[fieldName]?.docId );
      // setDisableButtonNext(false)
    }

};

const handleUpload = async (documentName: string,file:any , fieldName:string , docId?: string | null ) => {
    // if (!formData[fieldName]) return;
 
    const formData = new FormData();
    formData.append("file", file );
    formData.append("documentName", fieldName);
    formData.append("fieldName", documentName);
    formData.append("applicationId", applicationId);
    formData.append("schemeId",existData.scheme?.id)

 
    try {
      const res = await submitApmcFiles(formData, token, docId);
    
      
      if(res.success==false)
        {
        // alert(`${res.message}`)
        toast.success(`${res.message}`, { position: "top-right", autoClose: 5000 });
  
      }
      else if (res.success && res.docId) {
      // Store docId and documentName in formData
      setFormData(prev => ({
        ...prev,
        [fieldName]: {
          docId: res.docId,
          documentName: fieldName,
          fileName: documentName,
        }
      }));
    }
    } catch (error) {
      toast.error("File upload failed");
    } 
  };

const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const { name, value } = e.target;

  // Support nested fields using dot notation (e.g., 'sanctionOfAssistance.purpose')
  if (name.includes('.')) {
    const keys = name.split('.');
    setFormData(prev => {
      let updated = { ...prev };
      let ref = updated;
      for (let i = 0; i < keys.length - 1; i++) {
        if (!ref[keys[i]]) ref[keys[i]] = {};
        ref = ref[keys[i]];
      }
      ref[keys[keys.length - 1]] = value;
      return updated;
    });
  } else {
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  }
};

const handleAssistanceChange = (index: number, field: string, value: string) => {
  setDetailAssistanceReceived(prev =>
    prev.map((item, idx) =>
      idx === index ? { ...item, [field]: value } : item
    )
  );
};

const handleSubmit = async(obj:any)=>{


  const body ={
     docId:existData.applicationDataId,
     appStatusLevel:existData.appStatusLevel,
     status:existData.status,
     annexureOnePointOne:obj
  }

      // return true


  try {
    const submitForm = await submitAnnexureOnePointOneForm(token , body);
   
    if(submitForm.success)
    {
      
      return true
    }
   
  } catch (error) {
   
  }

}


  const fetchAllPurpose = async () => {
    const response = await getApmcSchemes();
    
    const purposes = response?.purpose || [];
   
    
  const purposeOptions = purposes.map((data) => ({
    label: data.subScheme,
    value: data.id
  }));

  
    
    setPurposes(purposeOptions);
  };

    const getExistedApplication = async () => {
     try {
          const response = await getExistedSchemesAplication(token, applicationId, id);
    
          if (response?.success) {
            
             setExistData(response?.data);
          }
        } catch (error) {
      
        }
      }

  useEffect(() => {
    fetchAllPurpose();
    getExistedApplication();

  }, []);


  useEffect(() => {
  if (existData) {
    const isAnnexureOnePointOne = existData?.annexureOnePointOne?.newData;
   

    if (isAnnexureOnePointOne) {
      // ✅ Case 1: newData present (direct object structure)
      const newData = isAnnexureOnePointOne.data || {};

      setFormData((prev) => ({
        ...prev,
        purpose: newData?.purpose || "",
        estimateProjectCostAmount: newData?.estimateProjectCostAmount || "",
        percentOfProjCostEligible: newData?.percentOfProjCostEligible || "",
        share: newData?.share || "",
      }));

      // For hasAssistanceApproved_*
    const allData =
        existData?.annexureThree?.hasAssistanceApproved?.data || [];

      const assistanceDataArray = allData.filter(
        (entry: any) =>
          typeof entry?.fieldName === "string" &&
          entry.fieldName.toLowerCase().startsWith("details")
      );

      const mappedDetails = assistanceDataArray.map((entry: any) => ({
        date: entry?.value?.date || "",
        scheme: entry?.value?.scheme || "",
        purpose: entry?.value?.purpose || "",
        amount: entry?.value?.amount || "",
        expenditure: entry?.value?.expenditure || "",
        shortfall: entry?.value?.shortfall || "",
        // share: entry?.value?.share || "",
        completion: entry?.value?.completion || "",
        assistance: entry?.value?.assistance||"",
        contribution: entry?.value?.contribution||""
      }));

      setDetailAssistanceReceived(mappedDetails);
    } else {
      // ✅ Case 2: old structure (array inside annexureOne/Three)
      setFormData((prev) => ({
        ...prev,
        purpose:
          existData?.annexureOne?.purposeOfAssistance?.data?.find(
            (d) => d.fieldName === "purpose"
          )?.value || "",
        estimateProjectCostAmount:
          existData?.annexureOne?.estimateProjectCost?.data?.find(
            (d) => d.fieldName === "estimateProjectCostAmount"
          )?.value || "",
        percentOfProjCostEligible:
          existData?.annexureOne?.percentOfProjCostEligible?.data?.find(
            (d) => d.fieldName === "percentOfProjCostEligible"
          )?.value || "",
      }));

      const allData =
        existData?.annexureThree?.hasAssistanceApproved?.data || [];

      const assistanceDataArray = allData.filter(
        (entry: any) =>
          typeof entry?.fieldName === "string" &&
          entry.fieldName.toLowerCase().startsWith("details")
      );

      const mappedDetails = assistanceDataArray.map((entry: any) => ({
        date: entry?.value?.date || "",
        scheme: entry?.value?.scheme || "",
        purpose: entry?.value?.purpose || "",
        amount: entry?.value?.amount || "",
        expenditure: entry?.value?.expenditure || "",
        shortfall: entry?.value?.shortfall || "",
        // share: entry?.value?.share || "",
        completion: entry?.value?.completion || "",
        assistance: entry?.value?.assistance||"",
        contribution: entry?.value?.contribution||""
      }));

      setDetailAssistanceReceived(mappedDetails);
    }
  }
}, [existData]);


  return (  
    <>
      {existData!=null && <div className="page-wrapper">
        <h2 className='p-2 px-5'>Application for Scheme - (Annexure-1.1)</h2>
        <DistrictPage
        applicationId={applicationId}
        certificate={certificate}
        siteInspectionPhotos={siteInspectionPhotos}
        formData={formData}
        handleInputChange={handleInputChange}
        handleFileChange={handleFileChange}
        detailAssistanceReceived={detailAssistanceReceived}
        setDetailAssistanceReceived={setDetailAssistanceReceived}
        handleSubmit={handleSubmit}
        purposes={purposes}
        setFormData={setFormData}
        existData={existData}
        handleAssistanceChange={handleAssistanceChange}
        />
    </div>}
    </>
  
  );
};
 
export default DistrictRegistar;
